// Lightweight GA4 event tracking. Safe to call even when GA is not loaded.
// window.gtag is set up by /components/Analytics.jsx once REACT_APP_GA_MEASUREMENT_ID is present.

export function trackEvent(name, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch (err) {
    // Never crash the app because of analytics
    if (typeof console !== "undefined" && console.error) {
      console.error("[analytics] trackEvent failed", { name, err });
    }
  }
}
